import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrderType } from 'src/app/@core/constants';
import { ColumnTable } from 'src/app/models/column-table';
import { Filter } from 'src/app/models/filter';
import { FilterTable } from 'src/app/models/filter-table';
import { OrderFilter } from 'src/app/models/filters/order-filter';
import { Order } from 'src/app/models/order';
import { Paging } from 'src/app/models/page';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'app-return-invoices-list',
  templateUrl: './return-invoices-list.component.html',
  styleUrls: ['./return-invoices-list.component.sass']
})
export class ReturnInvoicesListComponent implements OnInit {


  orders: Paging<Array<Order>> = new Paging([]);
  constructor(private orderService: OrderService, private invoiceService: InvoiceService, private configService: ConfigurationService, private router: Router) { }

  async ngOnInit(): Promise<void> {
    await this.getData({ page: 0, pageSize: 10, value: {} });
  }

  async getData(filter: Filter<OrderFilter>) {
    filter.value.orderType = OrderType.RETURN;
    filter.value.salesOrgCode = this.configService.readSelectedBranchAndSalesOrg().salesOrg.code;
    if (!filter.value.invoiceNumber) {
      filter.value.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
    }
    filter.value.includeCreditNotes = true;
    filter.value.isDummy = false;
    this.orders = (await this.orderService.readOrders(filter).toPromise()).response;
  }

  getHeaders() {
    return [
      new ColumnTable("code", "Número de Devolución"),
      new ColumnTable("creditNote", "Nota de Crédito"),
      new ColumnTable("customerCode", "Código de Cliente"),
      new ColumnTable("fullName", "Nombre del Cliente"),
      new ColumnTable('timeStamp', "Fecha", { type: "date" }),
      new ColumnTable('condition', "Condición", { type: "badge", valueMap: this.getConditionMap() }),
      new ColumnTable('netTotal', "Monto", { type: "currency" }),
      new ColumnTable("code", "Opciones", {
        type: "action", actions: [
          {
            fn: (order: Order) => {
              this.router.navigate(["/returnInvoices", order.code]);
            },
            icon: "fa fa-regular fa-circle-right",
            tooltip: "Detalle de Orden de Devolución",
            isDisabled: false
          }
        ]
      })
    ];
  }

  getFilters(): Array<FilterTable> {
    return [
      new FilterTable('text', "Búsqueda General"),
      new FilterTable('invoiceNumber', "Nota de Crédito"),
      new FilterTable('customerCode', "Código de Cliente"),
      new FilterTable('sellerCode', "Vendedor"),
      new FilterTable('condition', "Condición", { type: "combobox", comboBoxFilterValues: this.getConditionMap() }),
      new FilterTable("start", "Fecha Inicial", { type: "date" }),
      new FilterTable("end", "Fecha Final", { type: "date" }),
      //new FilterTable('digitalSignatureStatus', "Estado de firma digital", { type: "combobox", comboBoxFilterValues: this.getDigitalSignatureStatusMap() }),
    ];
  }

  create() {
    this.router.navigate(['returnInvoices', 'new'])
  }

  createManual() {
    this.router.navigate(['returnInvoices', 'newManual'])
  }

  private getConditionMap(): Map<string, string> {
    let result = new Map<string, string>();

    result.set("contado", "Contado");
    result.set("credito", "Crédito");

    return result;
  }
}
